// The store:
import createStore from "unistore";

const items = [
  {
    id: 1,
    name: "New South Wales",
    color: "red",
    coordinates: [146.9091796875, -32.026706293336126]
  },
  {
    id: 2,
    name: "Queensland",
    color: "blue",
    coordinates: [144.53613281249997, -22.75592068148639]
  },
  {
    id: 3,
    name: "Victoria",
    color: "red",
    coordinates: [145.4150390625, -37.16031654673676]
  },
  {
    id: 4,
    name: "Tasmania",
    color: "red",
    coordinates: [146.5576171875, -41.96765920367816]
  },
  {
    id: 5,
    name: "South Australia",
    color: "blue",
    coordinates: [136.0107421875, -30.06909396443886]
  },
  {
    id: 6,
    name: "Northern Territory",
    color: "blue",
    coordinates: [133.5498046875, -19.31114335506464]
  },
  {
    id: 7,
    name: "Western Australia",
    color: "blue",
    coordinates: [122.1240234375, -25.403584973186703]
  }
];

const store = createStore({
  filter: "all",
  items,
  activeItem: 0,
  hoverItem: 0
});

const actions = store => ({
  setFilter(state, filter) {
    const filteredItems = items.filter(item => {
      return filter === "all" || item.color === filter;
    });
    return {
      filter,
      items: filteredItems
    };
  },
  setActiveItem(state, activeItem) {
    return {
      activeItem
    };
  }
});

export { store, actions };
